module.exports = __webpack_public_path__ + "5fa3cd87f4bfac49d5349821184b232a.ttf";